export default __webpack_public_path__ + "static/media/36I-102747_-17356_0.411dca10.jpg";